import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../hooks/AuthProvider";
import { FORMS_FORM_IMAGE } from "../../../config/urls";

const cache = new Map();

// Loads an uploaded image of a form as a data URL (for the editor and preview).
const useFormImage = (formId, imageId) => {
  const { getValidToken } = useAuth();
  const tokenRef = useRef(getValidToken);
  tokenRef.current = getValidToken;
  const key = `${formId}:${imageId}`;
  const [url, setUrl] = useState(imageId ? cache.get(key) || "" : "");

  useEffect(() => {
    if (!formId || !imageId) {
      setUrl("");
      return undefined;
    }
    if (cache.has(key)) {
      setUrl(cache.get(key));
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const token = await tokenRef.current();
        const response = await fetch(FORMS_FORM_IMAGE(formId, imageId), {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": localStorage.getItem("tenant"),
          },
        });
        if (!response.ok) return;
        const data = await response.json();
        cache.set(key, data.data_url);
        if (!cancelled) setUrl(data.data_url);
      } catch (error) {
        // The placeholder stays; the issues panel reports a missing image.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [formId, imageId, key]);

  return url;
};

export default useFormImage;
